/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/* eslint-disable sort-keys */
import {Sandbox} from '@exc/core';

// NOTE: Reason for missing `serviceCode` and empty `access`:
// All companies have Launch but users have to be given permission as assigned by an Org Admin.
// If you visit Launch without having any permissions, the app
// will tell you to contact your Org Admin.

export default {
  appId: 'launch',
  distributionList: ['activation-engineering@adobe.com'],
  name: 'Launch',
  path: '/launch',
  sandbox: {
    hideInitialSpinner: true,
    history: Sandbox.HISTORY_TYPES.HISTORY,
    sources: {
      dev: 'https://localhost:9002',
      dev1: 'https://lens-dev.launch.adobe.net',
      qa: 'https://lens-qe1.launch.adobe.net',
      integration: 'https://launch-integration.adobe.com',
      stage: 'https://launch-stage.adobe.com',
      demo: 'https://launch-demo.adobe.com',
      prod: 'https://launch.adobe.com'
    }
  },
  access: []
};

